import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'

import {
  campaignCardPrimaryHref,
  resolveLandingCardStatus,
} from '@/features/campaigns/lib/campaign-landing-display'
import type { Campaign } from '@/features/campaigns/types'

import { DashboardIconAction, dashboardActionsRowSx } from './DashboardIconAction'

interface Props {
  campaign: Campaign
}

export function RecentCampaignRowActions({ campaign }: Readonly<Props>) {
  const navigate = useNavigate()
  const status = resolveLandingCardStatus(campaign)

  const go = (href: string) => () => {
    navigate(href)
  }

  if (status === 'draft') {
    return (
      <Box sx={dashboardActionsRowSx}>
        <DashboardIconAction
          variant="continue"
          label="Continue Building"
          testId={`admin-dashboard-campaign-continue-${campaign.id}`}
          onClick={go(campaignCardPrimaryHref(campaign))}
        />
      </Box>
    )
  }

  return (
    <Box sx={dashboardActionsRowSx}>
      <DashboardIconAction
        variant="launch"
        label="View Launching Screen"
        testId={`admin-dashboard-campaign-launch-${campaign.id}`}
        onClick={go(campaignCardPrimaryHref(campaign))}
      />
    </Box>
  )
}
